var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-title',[_c('v-img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require('@/assets/primar-textlogo.png'),"alt":"PRIMAR logo","contain":"","width":"200px"},on:{"click":function($event){return _vm.$router.push('/')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }